export default __webpack_public_path__ + "static/media/world-esg-summit.2d2a9d88.jpg";